import Typography from '@mui/material/Typography';
import React from 'react';

import CrowdRiffGallery from 'components/CrowdRiffGallery';
import Fluid from 'components/Fluid';

const CrowdRiff = ({ hash = 'fa1adb0efd9ecbd5,ea9130005448a9d1', title = 'Tag Us on Instagram', hashtag = '#SouthWalton' }) => (
	<Fluid layout="10 10 12 12" rowGap="0" className="crowdRiffGallery" style={{ textAlign: 'center' }} justifyContent="center">
		{title && <Typography variant="h4" component="div" className="crowdRiffGallery__subheader">
			{title}
		</Typography>}
		{hashtag && <Typography variant="h1" component="div" className="crowdRiffGallery__hashtag">
			{hashtag}
		</Typography>}
		{!!hash && hash?.split(',').map((h) => <CrowdRiffGallery key={h} hash={h} />)}
	</Fluid>
);

export default CrowdRiff;